import React from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import { IconDownload, IconPdf } from "@tabler/icons-react";

import font from "../assets/fonts/Firago/FiraGO-Regular.ttf";
import { is } from "date-fns/locale";

Font.register({
  family: "FiraGO",
  src: font,
});

const BORDER_COLOR = "#bfbfbf";
const BORDER_STYLE = "solid";
const COL1_WIDTH = 40;
const COLN_WIDTH = (100 - COL1_WIDTH) / 1;
const styles = StyleSheet.create({
  body: {
    padding: 50,
    fontFamily: "FiraGO",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },

  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  Header: {
    marginBottom: "8px",
    marginTop: "16px",
  },
  tableCol1Header: {
    width: COL1_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    width: COLN_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol1: {
    width: COL1_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: COLN_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
});

const ReviewTable = ({
  sender,
  receiver,
  orderInfo,
  selectedCities,
  deliveryMethods,
  peymentMethods,
  selectedDeliveryOrderType,
  pieces,
}) => (
  <Document>
    <Page style={styles.body}>
      <Text style={styles.Header}>გამგზავნის მონაცემები</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {sender.clientTypeId === "1" ? "სახელი" : "გამგზავნი"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{sender.name}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {sender.clientTypeId === "1" ? "გვარი" : "საკონტაქტო პირი"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{sender.contactName}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {sender.clientTypeId === "1" ? "პ/ნ" : "ს/კ"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{sender.idNumber}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>ტელეფონი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{sender.contactPhone}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>ქალაქი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {selectedCities.senderCityName}
            </Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>მისამართი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{sender.address}</Text>
          </View>
        </View>
      </View>

      <Text style={styles.Header}>მიმღების მონაცემები</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {receiver.clientTypeId === "1" ? "სახელი" : "გამგზავნი"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{receiver.name}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {receiver.clientTypeId === "1" ? "გვარი" : "საკონტაქტო პირი"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{receiver.contactName}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>
              {receiver.clientTypeId === "1" ? "პ/ნ" : "ს/კ"}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{receiver.idNumber}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>ტელეფონი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{receiver.contactPhone}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>ქალაქი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {selectedCities.receiverCityName}
            </Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>მისამართი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{receiver.address}</Text>
          </View>
        </View>
      </View>

      <Text style={styles.Header}>ტვირთის აღწერა</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>გზავნილის წონა (კგ)</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{orderInfo.weight}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>რაოდენობა</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{orderInfo.pieceQuantity}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>გზავნილის შეფასება </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{orderInfo.insuranceItemPrice}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>სერვისი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{selectedDeliveryOrderType}</Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>გადახდის მეთოდი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {
                peymentMethods.find(
                  (pay) => pay.id == orderInfo.paymentMethodId
                )?.value
              }
            </Text>
          </View>
        </View>
        <View style={styles.tableRow}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>მიტანის მეთოდი</Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {
                deliveryMethods.find(
                  (pay) => pay.id == orderInfo.deliveryMethodId
                )?.value
              }
            </Text>
          </View>
        </View>
      </View>
      <Text style={styles.Header}>ტვირთის დეტალური აღწერა</Text>
      {/* {pieces.map((piece, index) => (
        <>
          <Text style={styles.Header}>{index + 1}</Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol1}>
                <Text style={styles.tableCell}>სიმაღლე (სმ)</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{piece.height}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol1}>
                <Text style={styles.tableCell}>სიგრძე (სმ)</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{piece.length}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol1}>
                <Text style={styles.tableCell}>სიგანე (სმ)</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{piece.width}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={styles.tableCol1}>
                <Text style={styles.tableCell}>მოცულობითი წონა</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{piece.pieceVolume}</Text>
              </View>
            </View>
          </View>
        </>
      ))} */}
    </Page>
  </Document>
);

const GeneratePDF = ({
  sender,
  receiver,
  orderInfo,
  selectedCities,
  deliveryMethods,
  peymentMethods,
  selectedDeliveryOrderType,
  pieces,
  isPackage = false,
}) => {
  return (
    <div className="btn btn-primary">
      <PDFDownloadLink
        document={
          <ReviewTable
            sender={sender}
            receiver={receiver}
            orderInfo={orderInfo}
            selectedCities={selectedCities}
            deliveryMethods={deliveryMethods}
            peymentMethods={peymentMethods}
            selectedDeliveryOrderType={selectedDeliveryOrderType}
            pieces={pieces}
          />
        }
        fileName={`OrderReview-${new Date().toLocaleString() + ""}.pdf`}
      >
        {({ blob, url, loading, error }) =>
          loading ? (
            <>...</>
          ) : (
            <>
              {isPackage ? (
                <div className="text-blue-500 hover:text-blue-700">
                  <IconPdf size={20} />
                </div>
              ) : (
                <div
                  className="flex items-space-between gap-2"
                  style={{ cursor: "pointer", color: "#fff" }}
                >
                  <IconDownload className="w-[18px] h-[18px] " />
                  <span>გადმოწერა</span>
                </div>
              )}
            </>
          )
        }
      </PDFDownloadLink>
    </div>
  );
};

export default GeneratePDF;
